import React from 'react';
import PropTypes from 'prop-types';

const ArticlePortraitImage = ({ img }) => {
  return (
    <div className="article-portrait">
      <div className="article-portrait__wrapper">
        <div
          className="article-portrait__overflow"
          data-scroll=""
          data-scroll-speed="-1"
        >
          <img
            src={`https://admin.shoschool.com${img?.url}`}
            alt="картинка блога"
            className="article-portrait__image"
          />
        </div>
      </div>
    </div>
  );
};

ArticlePortraitImage.propTypes = {
  img: PropTypes.object,
};

export default ArticlePortraitImage;
